module.exports = __webpack_public_path__ + "img/e084b7b.png";